module.exports = __webpack_public_path__ + "static/media/5J.0b10a3ee.png";